
import { useNodeCanvasStore } from '../store';
import { v4 } from 'uuid';
import { NodeParameter } from './storeClasses/node';
import { defineComponent } from 'vue';
import { useGlobalStore } from '@/modules/globalModule/store';

export default defineComponent({
  name: 'NodeParams',
  props: {
    isShowParams: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ncStore: useNodeCanvasStore(),
      globalStore: useGlobalStore(),
      editModeParams: [] as string[],
      isInspectActive: false
    };
  },
  created() {
    const globalStore = useGlobalStore();
    const node = globalStore.getNode(this.ncStore.editingNodeId);
    if (!node) this.onExitModal();
    return;
  },
  methods: {
    onExitModal() {
      this.editModeParams = [];
      this.$emit('onExit');
    },
    onEditParam(id: string) {
      if (this.editModeParams.includes(id)) {
        this.editModeParams = this.editModeParams.filter((ea) => ea !== id);
      } else {
        this.editModeParams = [...this.editModeParams, id];
      }
    },
    onDeleteParam(id: string) {
      const globalStore = useGlobalStore();
      const node = globalStore.getNode(this.ncStore.editingNodeId);
      if (!node) return;
      node.removeParameter(id);
    },
    onAddParam() {
      const globalStore = useGlobalStore();
      const node = globalStore.getNode(this.ncStore.editingNodeId);
      if (!node) return;
      const id = v4();
      node.addParameter({ name: '', type: '', value: '', id });
      this.onEditParam(id);
    },
    onDup(param: NodeParameter) {
      const globalStore = useGlobalStore();
      const node = globalStore.getNode(this.ncStore.editingNodeId);
      if (!node) return;
      const id = v4();
      node.addParameter({
        name: param.name,
        type: param.type,
        value: param.value,
        id
      });
      this.onEditParam(id);
    }
  }
});
